import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { languageConfig, type SupportedLanguage } from '@/i18n'

function resolveLanguage(raw: string | undefined): SupportedLanguage {
  const candidate = raw?.substring(0, 2) as SupportedLanguage | undefined
  return candidate && candidate in languageConfig ? candidate : 'de'
}

export function useDirection() {
  const { i18n } = useTranslation()

  useEffect(() => {
    const lang = resolveLanguage(i18n.language)
    document.documentElement.dir = languageConfig[lang].dir
    document.documentElement.lang = lang
  }, [i18n.language])

  return languageConfig[resolveLanguage(i18n.language)].dir
}
